import {createStore, combineReducers, applyMiddleware} from 'redux';
import {routerReducer} from 'react-router-redux';
import thunk from "redux-thunk";
import * as API from 'api';
import {categoriesAsTree, categoriesToHash} from 'base/reducers/categories';
import {auth} from 'base/reducers/auth';
import {SEO} from './seo';
import {reducer as toastrReducer} from 'react-redux-toastr';
import popupProduct from 'base/reducers/product';
import shoppingCart from 'base/reducers/shopping-cart';
import breadcrumb from 'base/reducers/breadcrumb';
import {myBusinesses} from './my-businesses';
import conversationMessages from './conversation-messages';
import {listHomeBanners} from './home-banners';
import {persistStore, autoRehydrate, persistReducer} from 'redux-persist';
import localStorage from 'redux-persist/es/storage';
import { reducer as reduxAsyncConnect } from 'redux-connect';

const cartConfig = {
  key: 'shoppingCart',
  storage: localStorage,
}

let rootReducer = combineReducers({
  reduxAsyncConnect,
  categoriesAsTree,
  categoryHash: categoriesToHash,
  routing: routerReducer,
  auth,
  myBusinesses,
  conversationMessages,
  listHomeBanners,
  popupProduct,
  breadcrumb,
  SEO,
  toastr: toastrReducer,
  shoppingCart: persistReducer(cartConfig, shoppingCart)
});

let store = createStore(rootReducer, applyMiddleware(thunk));
persistStore(store);
export {store, rootReducer};



// WEBPACK FOOTER //
// ./reducers/index.js